var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5035 2.91367L16.6876 3.45761",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3375 7.49887H17.5216",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49716 2.91367L3.31308 3.45761",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66318 7.49887H2.4791",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6677 16.6694C11.2741 17.1942 10.6564 17.5031 10.0004 17.5031C9.34435 17.5031 8.72662 17.1942 8.33301 16.6694",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31083 10.8774V8.02002C5.31083 5.43011 7.41037 3.33057 10.0003 3.33057V3.33057C12.5902 3.33057 14.6897 5.43011 14.6897 8.02002V10.8774H14.6862L15.7616 11.9537C16.2383 12.4307 16.3807 13.1478 16.1224 13.7707C15.8642 14.3937 15.2562 14.7997 14.5819 14.7996H5.41868C4.74436 14.7997 4.13635 14.3937 3.87813 13.7707C3.6199 13.1478 3.76229 12.4307 4.23892 11.9537L5.31437 10.8774",
    stroke: "#262123",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.379ba58d824ad1b1f4ce94287fcfc81c.svg";
export { ForwardRef as ReactComponent };